import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy } from "core";
import { TaskPool } from "core/TaskPool";
import PropTypes from "prop-types";
import React from "react";
import { GenericAlert, GenericGrid, GenericTextInput } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";

class LoanApplicationCreditValidation extends React.Component {
	constructor(props) {
		super(props);

		this.columns = [
			{
				Header: "Type",
				accessor: "Type.ParameterDesc"
			},
			{
				Header: "Count",
				accessor: "Count"
			},
			{
				Header: "High Cred",
				accessor: "HighCred"
			},
			{
				Header: "Cred Limit",
				accessor: "CredLimit"
			},
			{
				Header: "Balance",
				accessor: "Balance"
			},
			{
				Header: "Past Due",
				accessor: "PastDue"
			},
			{
				Header: "Payment",
				accessor: "Payment"
			},
			{
				Header: "Available",
				accessor: "Available"
			}
		];

		this.sortedType = [{ id: "Type.ParameterValue", desc: false }];
		this.loadTaskPool = new TaskPool(this.handleLoadTaskPoolAppend, this.handleLoadTaskPoolCompleted);

		this.state = {
			isLoading: false

		};
	}

	componentDidMount() {

	}

	handleLoadTaskPoolCompleted = () => {
		this.setState({ isLoading: false });
	}

	handleLoadTaskPoolAppend = () => {
		this.setState({ isLoading: true });
	}
	ShowMessage = (type, title, message) => {
		this.setState({
			alert: <GenericAlert Title={title} Message={message} Type={type} OnConfirm={() =>
				this.setState({ alert: "" })} />
		});
	}
	HandleInguiryAction(value) {
		let data = { ApplicantId: value };
		this.setState({ isLoading: true });

		this.loadTaskPool.AppendTask(
			Proxy.POST(
				"/losapi/v1.0/Applicant/CheckTransCreditHistory",
				data,
				responseData => {
					this.setState({ isLoading: false });
					if (!responseData.IsSucceeded) {
						this.ShowMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					this.props.GetCreditHistory(data.ApplicantId, true);

				},
				error => {
					this.setState({ isLoading: false });
					this.ShowMessage("error", "Error", error);
				}
			));
	}

	SelectedRowChange = (e, index) => {

	}

	render() {
		var { model, Applicant } = this.props;
		var { isLoading } = this.state;


		return (
			<div>
				<LoadingComponent Show={isLoading} TaskPoolDomain={this.loadTaskPool} />
				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<GridContainer >
							<GridItem xs={4}>
								<GenericTextInput
									Disabled
									LabelText="Bankruptcies"
									Value={model.Bankruptcies} />
								<GenericTextInput
									Disabled
									LabelText="Banking Closed For Cause"
									Value={model.BankingClosedForCause} />
								<GenericTextInput
									Disabled
									LabelText="Collection Inquiries"
									Value={model.CollectionInquiries} />
								<GenericTextInput
									Disabled
									LabelText="Trade Last Opened"
									Value={model.TradeLastOpened} />
								<ParameterComponent
									Disabled
									LabelText="Id Mismatch Alert"
									ParameterCode="LMSIdMismatchAlert"
									Value={model.IdMismatchAlertId} />
								<GenericTextInput
									Disabled
									LabelText="Factors"
									Value={model.Factors} />
							</GridItem>
							<GridItem xs={4}>
								<GenericTextInput
									Disabled
									LabelText="Legal Items"
									Value={model.LegalItems} />
								<GenericTextInput
									Disabled
									LabelText="Registered Items"
									Value={model.RegisteredItems} />
								<GenericTextInput
									Disabled
									LabelText="Inquiries Within Six Months"
									Value={model.InquiriesWithinSixMonths} />
								<GenericTextInput
									Disabled
									LabelText="Current Negative Trade"
									Value={model.CurrentNegativeTrade} />
								<ParameterComponent
									Disabled
									LabelText="High Risk Fraud Alert"
									ParameterCode="LMSHighRiskFraudAlert"
									Value={model.HighRiskFraudAlertId} />
							</GridItem>
							<GridItem xs={4}>
								<GenericTextInput
									Disabled
									LabelText="Collections"
									Value={model.Collections} />
								<GenericTextInput
									Disabled
									LabelText="Inquiries"
									Value={model.Inquiries} />
								<GenericTextInput
									Disabled
									LabelText="Trade First Opened"
									Value={model.TradeFirstOpened} />
								<GenericTextInput
									Disabled
									LabelText="Paid Trade"
									Value={model.PaidTrade} />
								<GenericTextInput
									Disabled
									LabelText="Credit Vision Risk Score"
									Value={model.CreditVisionRiskScore} />
							</GridItem>
						</GridContainer>
					</GridItem>
					<GridItem xs={12} style={{ mt: 15 }}>
						<br />
						{Applicant.Id && Applicant.Id > 0 && Applicant.IdVerificationStatus != null && Applicant.IdVerificationStatus &&
							<GridContainer direction="row" justify="center" alignItems="flex-start">
								<GridItem xs={6}></GridItem>
								<GridItem xs={6}>
									<GridContainer justify="flex-end">
										<GridItem xs={4}>
											<Button size="sm" onClick={() => { this.HandleInguiryAction(Applicant.Id); }} fullWidth>Credit History Check</Button>
										</GridItem>

									</GridContainer>
								</GridItem>
							</GridContainer>
						}
						<GenericGrid
							HideButton
							Data={model.CreditHistoryDetails || []}
							Columns={this.columns}
							Sorted={this.sortedType}
							RowSelected={index => {
								this.SelectedRowChange(0, index);
							}}
						/>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

LoanApplicationCreditValidation.propTypes = {
	model: PropTypes.object,
	Applicant: PropTypes.object,
	GetCreditHistory: PropTypes.func
};

export default LoanApplicationCreditValidation;